module.exports = __webpack_public_path__ + "img/2015-03-28.e335f46e.jpg";